import { CoralogixRum } from "@coralogix/browser";
import { isProdEnv } from "./env";
import pkg from '../../package.json';
import { BootResponse } from "constants/apiResponses.types";
import { getEnvVariable } from "@appcharge/shared-ui";

const DEFAULT_CORALOGIX_APPLICATION = 'store-fe-prod';
const DEFAULT_CORALOGIX_PUBLIC_KEY_PROD = 'cxtp_TcaSLgpasuUkaEzk6BexF8nOwvv5LE';
const DEFAULT_CORALOGIX_SESSION_SAMPLE_RATE_PROD = 1;
const DEFAULT_CORALOGIX_SESSION_SAMPLE_RATE_DEV = 1;

export const initCoralogixRum = (publisherMetaData: BootResponse) => {
    CoralogixRum.init({
        stringifyCustomLogData: true,
        public_key: getEnvVariable('REACT_APP_CORALOGIX_PUBLIC_KEY', process.env.REACT_APP_CORALOGIX_PUBLIC_KEY) || DEFAULT_CORALOGIX_PUBLIC_KEY_PROD,
        application: getEnvVariable('REACT_APP_CORALOGIX_APPLICATION', process.env.REACT_APP_CORALOGIX_APPLICATION) || DEFAULT_CORALOGIX_APPLICATION,
        version: pkg.version,
        coralogixDomain: 'US2',
        sessionConfig: {
            sessionSampleRate: isProdEnv() ? DEFAULT_CORALOGIX_SESSION_SAMPLE_RATE_PROD : DEFAULT_CORALOGIX_SESSION_SAMPLE_RATE_DEV,
            alwaysTrackSessionsWithErrors: true,
        },
        debug: process.env.NODE_ENV === 'development',
    });
    CoralogixRum.setUserContext({
        user_id: publisherMetaData.storeTheme.publisherId,
        user_name: publisherMetaData.storeTheme.general.storeTabName,
        user_email: '',
        user_metadata: {
            publisherId: publisherMetaData.storeTheme.publisherId,
            environment: getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) || 'unknown',
            version: pkg.version,
        },
    });

    CoralogixRum.setLabels({
        publisherId: publisherMetaData.storeTheme.publisherId,
        environment: getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) || 'unknown',
        version: pkg.version,
        storeName: publisherMetaData.storeTheme.general.storeTabName,
    });
};